import { Container } from "components/layout/Container";
import { Heading } from "components/layout/Heading";
import s from "./SectionLandingBenefits.module.scss";
import cs from "@/styles/modules/card.module.scss";
import cn from "classnames";
import { WrappedIcon } from "@/components/UI/WrappedIcon";

type SectionLandingHowProps = {
  heading: string;
  subheading?: string;
  items: {
    title: string;
    text: string;
    image?: {
      src: string;
      src2x: string;
    };
  }[];
  benefits?: {
    title: string;
    text: string;
    image?: {
      src: string;
      src2x: string;
    };
  }[];
};

export const SectionLandingBenefits = ({ heading, subheading, items, benefits }: SectionLandingHowProps) => {
  const targetItems = items || benefits;
  return (
    <section className={s.section}>
      <Container>
        <Heading
          title={heading}
          subheading={subheading}
          image="/img/icons/60/gift.png"
          className={s.heading}
        />
        {!!targetItems?.length && (
          <ul
            className={cn(s.items, {
              [s.grid2]: targetItems.length % 3,
              [s.grid3]: !(targetItems.length % 3),
            })}
          >
            {targetItems.map((item, index) => (
              <li className={cn(cs.cardGlassHover, s.item)} key={index}>
                {item.image && <WrappedIcon icon={item.image.src2x || item.image.src} />}
                <strong className={cn(cs.h4, s.itemTitle)} dangerouslySetInnerHTML={{ __html: item.title }} />
                <p>{item.text}</p>
              </li>
            ))}
          </ul>
        )}
      </Container>
    </section>
  );
};

export default SectionLandingBenefits;
